import { Info, Trash2 } from "@fg/icons";
import { useTrash } from "@/api/hooks";
import { Button } from "@/components/ui/button";
import { useDriveActions } from "./driveActions";
import { DriveView, PageTitle } from "./DriveView";
import { EmptyState } from "./EmptyState";

/** Bin: restore, delete forever, empty. Items auto-delete after 30 days. */
export function TrashPage() {
    const trash = useTrash();
    const actions = useDriveActions();
    const count = trash.data?.length ?? 0;
    return (
        <DriveView
            variant="trash"
            label="Items in the bin"
            title={<PageTitle icon={Trash2}>Bin</PageTitle>}
            headerExtra={
                <Button
                    variant="ghost"
                    size="sm"
                    disabled={count === 0}
                    onClick={() => void actions.emptyBin(count)}
                    className="shrink-0 text-destructive hover:bg-destructive/10 hover:text-destructive"
                >
                    Empty bin
                </Button>
            }
            banner={
                <div className="flex items-center gap-2.5 rounded-lg bg-muted/70 px-4 py-2.5 text-sm text-muted-foreground" role="note">
                    <Info className="h-4 w-4 shrink-0" aria-hidden />
                    Items in the bin are deleted forever after 30 days.
                </div>
            }
            query={trash}
            resetKey="trash"
            emptyState={<EmptyState icon={Trash2} tone="rose" title="Bin is empty" description="Items you move to the bin show up here." />}
        />
    );
}
